import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { ConfidenceLevel } from '../../types/experiment.types';

interface ConfidenceBadgeProps {
  level: ConfidenceLevel;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

const CONFIDENCE_CONFIG: Record<ConfidenceLevel, { color: ChipProps['color']; label: string }> = {
  HIGH: { color: 'success', label: 'High Confidence' },
  MEDIUM: { color: 'warning', label: 'Medium Confidence' },
  LOW: { color: 'error', label: 'Low Confidence' },
  INSUFFICIENT: { color: 'default', label: 'Insufficient Data' },
};

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({ 
  level, 
  size = 'medium',
  variant = 'filled'
}) => {
  const config = CONFIDENCE_CONFIG[level];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      variant={variant}
      sx={{
        fontWeight: 600,
      }}
    />
  );
};

export default ConfidenceBadge;
